import { FC, PropsWithChildren } from 'react';
import { useLayout } from '../contexts/layout/LayoutContext';

/**
 * Conditionally renders children only when not in embedded/iframe mode.
 * Use this to hide UI elements that should not appear when the app is embedded.
 */
export const HideInEmbeddedMode: FC<PropsWithChildren> = ({ children }) => {
    const { isEmbeddedMode } = useLayout();
    if (isEmbeddedMode) return null;
    return <>{children}</>;
};
